import * as jsxRuntime from "C:\\Eidos!!!\\Mylo\\44-eido-mylo\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment